import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import api from "@/lib/api";
import Home from "@/pages/Home";
import StoryReader from "@/pages/StoryReader";
import Admin from "@/pages/Admin";

function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    api.post("/auth/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        navigate("/admin", { replace: true });
      })
      .catch((err) => {
        const detail = err.response?.data?.detail;
        toast.error(typeof detail === "string" ? detail : "Inloggen met Google is mislukt");
        setUser(false);
        navigate("/admin", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-sand-50 flex items-center justify-center font-sans text-sm font-light text-sand-900/50">
      Bezig met inloggen via Google…
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/verhaal/:slug" element={<StoryReader />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PlayerProvider>
          <AppRouter />
          <Toaster position="bottom-center" />
        </PlayerProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
